import round from 'lodash/round';

import { ResourceMetrics } from 'features/workload-optimization';

export const isResourcePositive = ({
  recommended,
  requested,
}: ResourceMetrics): boolean | number | undefined => {
  const _requested = requested ? round(requested, 3) : undefined;
  const _recommended = recommended ? round(recommended, 3) : undefined;
  return _requested && _recommended && _requested === _recommended;
};
